import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';

import { useChatButtonContextValue } from './hooks';
import { useBuilderChat } from '../../hooks/useBuilderChat';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { setBuilderChatButtonClicked } from '../../slices/builderChat';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';

interface IBuilderChatButtonContainerProps {
  asIcon?: boolean;
  buttonSize?: TButtonSize;
  buttonTheme?: TButtonTheme;
  withOnboarding?: boolean;
}

export const BuilderChatButtonContainer: React.FC<IBuilderChatButtonContainerProps> = ({
  asIcon = false,
  buttonSize = 'M',
  buttonTheme = 'fill_primary',
  withOnboarding = false,
}) => {
  const isChatEnabled = useSelector(getBuilderChatEnabled);
  const chatButtonContextValue = useChatButtonContextValue();

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(setBuilderChatButtonClicked());
  }, [dispatch]);

  const { openChat } = useBuilderChat();

  if (!isChatEnabled) {
    return null;
  }

  const beforeIcon = (
    <IconCommunicationMessage16
      color={buttonTheme === 'fill_primary' ? 'icon-inverted-default' : 'icon-main-default'}
    />
  );

  const messageButton = asIcon ? (
    <CianNewbuildingChatButton
      aria-label="Написать"
      beforeIcon={beforeIcon}
      fullWidth
      onClick={handleButtonClick}
      onChatOpen={openChat}
      size={buttonSize}
      theme={buttonTheme}
    />
  ) : (
    <CianNewbuildingChatButton
      beforeIcon={beforeIcon}
      fullWidth
      onClick={handleButtonClick}
      onChatOpen={openChat}
      size={buttonSize}
      theme={buttonTheme}
    >
      Написать
    </CianNewbuildingChatButton>
  );

  const contextualizedMessageButton = (
    <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
      {messageButton}
    </CianNewbuildingChatButtonContext.Provider>
  );

  if (withOnboarding) {
    return <ChatOnboardingContainer type="builder">{contextualizedMessageButton}</ChatOnboardingContainer>;
  }

  return contextualizedMessageButton;
};
